import FallbackUtil from 'src/components/Video/FallbackUtil';
import Utils from 'src/utils/Utils';
import logger from 'src/utils/logger/logger';

import { utilsPlayersControls } from 'src/playerDomain/components/utils/index'

const setTimeshiftEventInfo = (timeshiftEventInfo, _this) => {
  _this.resetLiveTimeshift();
  _this.switchingBetweenEventTimeshift = false;
  /**
  * Evento a playear
  */
  let timeshiftAllowed = 0, channelNumber = '', channelImage = '', eventTitle = '';
  const groupId = timeshiftEventInfo && timeshiftEventInfo.event ? timeshiftEventInfo.event.group_id : '';

  if (groupId) {
      const channelInfo = ChannelStreamUtil.get(groupId);
      channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
      channelImage = channelInfo ? channelInfo.imageEpg || '' : '';
      timeshiftAllowed = ChannelSingleton.getTimeshift(groupId, true);
      timeshiftEventInfo.channelTimeshiftAllowed = timeshiftAllowed;
  }
  eventTitle = timeshiftEventInfo && timeshiftEventInfo.event && timeshiftEventInfo.event.name ? timeshiftEventInfo.event.name : '';
  _this.setState({ timeshiftEventInfo }, () => {
      _this.updateChannelInfo(channelNumber, channelImage, eventTitle);
  });
}

const newTimesPlayer = (isBackward, seekTime, _this) => {
    logger.debug(
        '[NPC] Startover Vemos los nuevos tiempos que se tienen en el player  -isBackward - seekTime ',
        isBackward,
        seekTime
    );
    _this.setOperatorsSeek({ isBackward, seekTime });
    // TODO Esto de abajo se debe hacer desde el class father para que muestre la barra
    // TODO _this.show();
    const secs = isBackward ? -seekTime : seekTime;
    let curTime = _this.getCurrentTime();
    if (_this.seekInPause) {
        curTime = _this.seekInPause;
    }
    let newSecs = curTime + (_this.seekTime += secs);
    if (newSecs < 0) {
        newSecs = 0;
    }
    if (newSecs > _this.getDuration()) {
        newSecs = _this.getDuration() - 1;
    }
    logger.debug(
        '[NPC] calculateFinalSeekTime',
        '\nisBackward ' + isBackward,
        '\nnewSeekTime ' + seekTime,
        '\nseekTime ' + _this.seekTime,
        '\nnewSecs ' + newSecs,
        '\ncurTime ' + curTime
    );
    _this.updateCurrentTimeUI(newSecs);
    // TODO _this.updateSprite(newSecs);
    //doSeek(newSecs, curTime, _this);
};

const calculateFinalSeekTime = (isBackward, seekTime, _this) => {
    FallbackUtil.clearFallback();
    if (_this.state.timeshiftEventInfo && _this.state.timeshiftEventInfo.event) {
        // TODO revisar si esta bandera realmente se usa ¿?
        if (_this.switchingBetweenEventTimeshift) {
            logger.debug('[NPC] Startover function handleTimeshiftSeekByEvent rejected*****> ');
            return;
        }

        if (_this.hasTimeshift()) {
            if (_this.timerTimeshitDelayId) clearTimeout(_this.timerTimeshitDelayId);
            _this.setOperatorsSeek({ isBackward, seekTime });
            const currTime = _this.getCurrentTime();
            if (isBackward) {
                if (!_this.waitForSeconds) _this.waitForSeconds = true;
                const threshold_seconds = 0.25 * 60;
                if (
                    Utils.nowAsTimestampSeconds() -
                        _this.state.timeshiftEventInfo.event.date_begin >
                    threshold_seconds
                ) {
                    const newCurrentTime = currTime - seekTime < 0 ? 0 : currTime - seekTime;
                    _this.setCurrentTime(newCurrentTime);
                    if (newCurrentTime < currTime) {
                        _this.timeshiftTime = newCurrentTime;
                        // Si estamos en pausa y regresamos todo a cero, entons hacemos seek cero cuando se reanude el play
                        if (_this.pendingStartoverOnPause !== null && newCurrentTime === 0) {
                            _this.pendingStartoverOnPause = null;
                        }
                    }
                    _this.backwardIsMoving = true;
                }
            }
            // Si es forward, sólo si esta en pausa el live se permite mover el punto
            // en que puso la pausa
            else {
                if (Utils.nowAsTimestampSeconds() > _this.state.timeshiftEventInfo.event.date_end) {
                    return;
                }

                if (!_this.waitForSeconds) _this.waitForSeconds = true;

                const threshold_seconds_forward = 0.25 * 60; // no se permite avanzar hasta el now del evento, sólo hasta 25 segs antes
                //let acum_forward = currTime + _this.state.timeshiftEventInfo.event.date_begin;
                const limit_forward =
                    _this.state.timeshiftEventInfo.event.date_end -
                    Utils.nowAsTimestampSeconds() -
                    threshold_seconds_forward;
                const dur_limit_forward =
                    _this.state.timeshiftEventInfo.event.date_end -
                    _this.state.timeshiftEventInfo.event.date_begin -
                    limit_forward;

                let newCurrentTime;
                if (currTime + seekTime > dur_limit_forward) {
                    _this.switchingBetweenEventTimeshift = true;
                    _this.waitForSeconds = false;
                    logger.debug(
                        '[NPC]> function handleTimeshiftSeekByEvent skip to live > ' +
                            _this.switchingBetweenEventTimeshift
                    );
                    FallbackUtil.clearFallback();
                    _this.props.hide();
                    _this.props.goToLive(_this.props.setTimer);

                    _this.resetLiveTimeshift();

                    return;
                } else {
                    newCurrentTime = currTime + seekTime;
                }

                _this.setCurrentTime(newCurrentTime);

                if (newCurrentTime > currTime) {
                    _this.timeshiftTime = newCurrentTime;
                } else {
                    _this.timeshiftTime = dur_limit_forward;
                }

                _this.backwardIsMoving = true;
            }

            const timeshiftDelay = _this.getDuration() - _this.getCurrentTime();
            const timeshiftData = {
                timeshiftEvent: Object.assign({}, _this.state.timeshiftEventInfo.event),
                backward: true,
                // Si es negativo o no, se verifica en video/component, quien es quien decide
                // si se va o no a pgm o solo hace seek sobre el actual playing
                seektime: _this.timeshiftTime,
                maxtimeshiftallowed: _this.state.timeshiftEventInfo.channelTimeshiftAllowed,
                timeshiftDelay,
            };

            logger.debug(
                '[NPC] PlayerControls > handleTimeshiftSeekByEvent > _this.getCurrentTime() : ',
                _this.getCurrentTime()
            );

            newTimesPlayer(isBackward, seekTime, _this);

            if (_this.pendingStartoverOnPause !== null) {
                return;
            }

            _this.timerTimeshitDelayId = setTimeout(() => {
                _this.timerTimeshitDelayId = null;
                utilsPlayersControls.performTimeshift(timeshiftData, _this);
                _this.resetLiveTimeshift();
            }, _this.delayTimeshiftSeek);

        }
    }
};

export const seekStartOver = {
    calculateFinalSeekTime,
};



// WEBPACK FOOTER //
// ./src/playerDomain/components/seeks/seekStartOver.js